import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getRpmCliniiView } from "app/services/rpm/rpmService";
import { BASE_URL } from "static/constants";

export const rpmApi = createApi({
  reducerPath: "rpmApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getRpmCliniiView: query({
      queryFn: () => {
        return { data: getRpmCliniiView() };
      },
    }),
  }),
});

export const { useGetRpmCliniiViewQuery } = rpmApi;
